import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import classnames from "classnames";
import MemberAccept from "./MemberAccept";
import moment from "moment";


class MemberTransferList extends Component {

    constructor(props) {
        super(props);

        this.state = {

            aliasList: null,
            cities: this.props.location.cities,
            addAcceptModal: false,
            mode: this.props.location.mode,
            selectedMember: null,
            branches: null,
            members: [],
            transferLogs: [],
            file: "",
            loading: false,
            loading2: false,
            searching: false,
            searching2: false,
            searchQuery: "",
            searchQuery2: "",
            total: 0,
            total2: 0,
            page: 0,
            page2: 0,
            size: 10,
            size2: 10,
            manual: false,
            manual2: false,
            addOpCertModal: false,
            func: null,
            activeTab: '1',
        };

        this.toggle = this.toggle.bind(this);
        this.listMembers = this.listMembers.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearch2 = this.handleSearch2.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.listTransferLogs = this.listTransferLogs.bind(this);


        this.listCities = this.listCities.bind(this);
        this.listBranches = this.listBranches.bind(this);
        this.cancelTransfer = this.cancelTransfer.bind(this);
        this.handleLogout = this.handleLogout.bind(this);


    }

    componentDidMount() {
        this.listCities();
        this.listBranches();
    }


    listBranches() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/oda/oda-list/",
            method: "get",
        };
        console.log(params.url);
        request(params)
            .then(function (response) {
                let branches = response.data;
                console.log("branches", branches);
                self.setState({
                    branches,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listCities() {
        let self = this;
        let params = {
            //url: API_BASE_URL+"/city/listByBranch/" ,
            url: API_BASE_URL + "/city/",
            method: "get",
        };
        console.log(params.url);
        request(params)
            .then(function (response) {
                let cities = response.data;
                self.setState({
                    cities,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    toggle(tab) {
        this.setState({
            activeTab: tab
        })
    }


    listMembers(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,asc";
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let url = API_BASE_URL + "/uye/fetchTransferMemberByBranch?page=" + page + "&size=" + size + sortStr + searchQuery
        let params = {
            url: url,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                console.log(response.data.content);
                let members = response.data.content;
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    members,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }


    listTransferLogs(accessor2, direction2, page2, size2) {
        let self = this;
        let sortStr2 = !!accessor2 ? ("&sort=" + accessor2 + ',' + direction2) : "&sort=id,desc";
        let searchQuery2 = !self.state.searchQuery2 ? '' : '&' + self.state.searchQuery2;
        let url = API_BASE_URL + "/transferLogs/fetch?page=" + page2 + "&size=" + size2 + sortStr2 + searchQuery2;
        let params = {
            url: url,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading2: true, manual2: self.manual2 === true ? false : self.manual2, searching2: true});
        request(params)
            .then(function (response) {
                console.log(response.data.content);
                let transferLogs = response.data.content;
                self.setState({
                    page2: page2,
                    size2: size2,
                    total2: response.data.totalElements,
                    transferLogs,
                    loading2: false,
                    searching2: false
                });
            }).catch(function (error) {
            self.setState({loading2: false, searching2: false});
            showAxiosError(error);

        });
    }

    handleEdit(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedMember: response.data,
                addOpCertModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listMembers(this.state.accessor, this.state.direction, this.state.page, this.state.size))
    }

    handleSearch2(searchQuery2) {
        this.setState({
            searchQuery2,
            searching2: true
        }, () => this.listTransferLogs(this.state.accessor2, this.state.direction2, 0, this.state.size2))
    }

    cancelTransfer() {
        this.setState({
            addAcceptModal: false,
            selectedMember: null,
        })
    }

    handleLogout() {
        this.props.handleLogout();
    }

    handleTransfer(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedMember: response.data,
                addAcceptModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });


        /*let message = 'Üye Odaya Başarıyla Kabul Edildi.'
        let params2 = {
            url: API_BASE_URL + "/uye/accept-transfer/"+item.id,
            method: 'get'
        };
        request(params2).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
            self.setState({isLoading:false});
            self.handleSearch();
        }).catch(function (error) {
            self.setState({isLoading:false});
            showAxiosError(error);
        });*/
    }

    render() {
        const {members} = this.state;
        const selectState = [{value: null, label: "Tümü"}, {value: "1", label: "İstek Gönderildi"}, {
            value: "2",
            label: "İptal Edildi"
        }, {value: "3", label: "Kabul Edildi"}]

        const columns = [
            {
                Header: "Ad",
                accessor: "ad",
            },
            {
                Header: "Soyad",
                accessor: "soyad",
            },
            {
                Header: "Sicil No",
                accessor: "odaSicilNo",
            },
            {
                Header: "Kayıt Tarihi",
                accessor: "",
                Cell: item => (
                    <label>{new Date(item.odaKayitTarihi).toLocaleDateString('tr')}</label>
                )
            },
            {
                Header: "Şehir",
                accessor: "",
                Cell: item => (
                    <label>{item.city.ad}</label>
                )
            },
            {
                Header: "Bulunduğu Oda",
                accessor: "",
                Cell: item => (
                    <label>{item.city.oda.ad.toString().substring(0, 25) + "..."}</label>
                )
            },
            {
                Header: "Transfer Edileceği Şehir",
                accessor: "",
                Cell: item => (
                    <label>{this.state.cities && this.state.cities[item.transferTo - 1].ad}</label>
                )
            },
            {
                Header: "Transfer Edileceği Oda",
                accessor: "",
                Cell: item => (
                    <label>{this.state.cities && this.state.cities[item.transferTo - 1].oda.ad.toString().substring(0, 25) + "..."}</label>
                )
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <button type="button"
                                onClick={() => this.handleTransfer(item)}
                                data-toggle="tooltip" data-placement="bottom" title="Görüntüle"
                                style={{background: 'linear-gradient(#469fdab5, #469fda)'}}
                                rel="tooltip" className="Btn btn-sm btn-icon">
                            <i className="fa fa-search"/>
                        </button>
                    </div>
                )
            }
        ];


        const columns2 = [
            {
                Header: "Ad ",
                accessor: "",
                Cell: item => (
                    <label>{item.member.ad}</label>
                )
            },
            {
                Header: "SoyAd ",
                accessor: "",
                Cell: item => (
                    <label>{item.member.soyad}</label>
                )
            },
            {
                Header: "Sicil No ",
                accessor: "",
                Cell: item => (
                    <label>{item.member.odaSicilNo}</label>
                )
            },
            {
                Header: "Transfer İstek Tarihi ",
                accessor: "",
                Cell: item => (
                    <label>{item.createdAt ? moment.utc(item.createdAt).local().format("DD.MM.YYYY HH:mm:ss") : "-"}</label>)
            },
            {
                Header: "Önceki Şehir",
                accessor: "",
                Cell: item => (
                    <label>{item.fromCity}</label>
                )
            },
            {
                Header: "Önceki Oda",
                accessor: "",
                Cell: item => (
                    <label>{item.fromBranch}</label>
                )
            },
            {
                Header: "Tranfer Olduğu Şehir",
                accessor: "",
                Cell: item => (
                    <label>{item.toCity}</label>
                )
            },
            {
                Header: "Transfer Olduğu Oda",
                accessor: "",
                Cell: item => (
                    <label>{item.toBranch}</label>
                )
            },
            {
                Header: "Transfer Durumu",
                accessor: "",
                Cell: item => (
                    <label>{item.state === 1 ?
                        <label style={{color: 'blue'}}> İstek Gönderildi </label> : item.state === 2 ?
                            <label style={{color: 'red'}}> İptal Edildi </label> : item.state === 3 ?
                                <label style={{color: 'green'}}> Kabul Edildi </label> : ""}</label>
                )
            },
            {
                Header: "İşlem Tarihi ",
                accessor: "",
                Cell: item => (
                    <label>{item.completedAt ? moment.utc(item.completedAt).local().format("DD.MM.YYYY HH:mm:ss") : "-"}</label>)
            },


        ];


        const fields = [
            {
                label: "Ad",
                accessor: "ad",
                type: "text",
                operator: "=",
            },
            {
                label: "Soyad",
                accessor: "soyad",
                type: "text",
                operator: "=",
            },
            {
                label: "Oda Sicil No",
                accessor: "odaSicilNo",
                type: "text",
                operator: "=",
            },
            {
                label: "TC Kimlik No",
                accessor: "tcKimlikNo",
                type: "text",
                operator: "=",
            },
            {
                label: "Telefon No",
                accessor: "telefonNo",
                type: "text",
                operator: "=",
            },

        ];

        const fields2 = [
            {
                label: "Ad",
                accessor: "member.ad",
                type: "text",
                operator: "=",
            },
            {
                label: "Soyad",
                accessor: "member.soyad",
                type: "text",
                operator: "=",
            },
            {
                label: "Oda Sicil No",
                accessor: "member.odaSicilNo",
                type: "text",
                operator: "=",
            },
            {
                label: "Transfer Durumu ",
                accessor: "state",
                type: "select",
                operator: "=",
                selectData: selectState,
            },
            {
                label: "Önceki Oda",
                accessor: "fromBranch",
                type: "text",
                operator: "=",
            },

            {
                label: "Transfer Olduğu Oda",
                accessor: "toBranch",
                type: "text",
                operator: "=",
            },
            {
                label: "Önceki Şehir",
                accessor: "fromCity",
                type: "text",
                operator: "=",
            },
            {
                label: "Transfer Olduğu Şehir",
                accessor: "toCity",
                type: "text",
                operator: "=",
            },
            {
                label: "TC Kimlik No",
                accessor: "member.tcKimlikNo",
                type: "text",
                operator: "=",
            },

            {
                label: "İşlem Tarihi (...'den Sonra)",
                accessor: "completedAt",
                type: "date",
                operator: ">=",
            }

        ];


        return (
            <div className="content user-form-container">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({active: this.state.activeTab === '1'})}
                            onClick={() => {
                                this.toggle('1');
                            }}>
                            Transfer Kabul
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({active: this.state.activeTab === '2'})}
                            onClick={() => {
                                this.toggle('2');
                            }}>
                            Transfer İşlemleri Tarihçesi
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab} className="tab-content">
                    <TabPane tabId="1">
                        <div className="row baseBackground">

                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch}/>
                            </div>
                            <div className="card-body">
                                <Table
                                    loading={this.state.loading}
                                    loadingText="Kayıtlar getiriliyor..."
                                    content={members}
                                    total={this.state.total}
                                    page={this.state.page}
                                    manual={this.state.manual}
                                    size={this.state.size}
                                    options={["5", "10", "20", "50", "100"]}
                                    columns={columns}
                                    fetchData={this.listMembers}
                                />
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tabId="2">

                        <div className="row baseBackground">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields2}
                                                loading={this.state.searching2}
                                                onSearch={this.handleSearch2}/>
                            </div>
                            <div className="card-body">
                                <Table
                                    loading={this.state.loading2}
                                    loadingText="Kayıtlar getiriliyor..."
                                    content={this.state.transferLogs}
                                    total={this.state.total2}
                                    page={this.state.page2}
                                    manual={this.state.manual2}
                                    size={this.state.size2}
                                    options={["5", "10", "20", "50", "100"]}
                                    columns={columns2}
                                    fetchData={this.listTransferLogs}
                                />
                            </div>
                        </div>
                    </TabPane>

                </TabContent>
                <Modal isOpen={this.state.addAcceptModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelTransfer}>
                        Üye Transfer Kabul Ekranı
                    </ModalHeader>
                    {<ModalBody>
                        <MemberAccept cancelProcess={this.cancelTransfer} selectedMember={this.state.selectedMember}
                                      mode={this.state.mode}
                                      module={this.props.name} cities={this.state.cities}
                                      handleSearch={this.handleSearch}
                                      searchQuery={this.state.searchQuery}
                                      handleLogout={this.handleLogout}/>
                    </ModalBody>
                    }
                </Modal>
            </div>
        )
    }
}

export default MemberTransferList


// WEBPACK FOOTER //
// ./src/page/memberTransferList/MemberTransferList.js